import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { BankIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import { toast } from 'sonner'

import { createLecBankAccount } from '../../api/lec-bank-accounts/create-lec-bank-account'
import UserNavBar from '../../components/elements/nav-bar'
import { LecBankAccountForm } from '../../components/pages/lec-bank-accounts/lec-bank-account-form'
import { Paths } from '../../lib/constants/path'
import { updateButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const LecBankAccountCreatePage = () => {
  const { navigate } = useNavigator()
  const [formKey, setFormKey] = useState(0) // Using form key to reset the form since we are on the same page

  const { mutateAsync: createLecBankAccountMutation } = useMutation({
    mutationFn: createLecBankAccount,
    mutationKey: ['create-lec-bank-account'],
    onError: showAxiosError,
    onSuccess: () => toast.success('Compte bancaire LEC créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un nouveau compte bancaire LEC'} icon={BankIcon} />
      <div className={'h-4'} />
      <Box>
        <LecBankAccountForm
          key={formKey}
          buttonsConfig={updateButtonsConfig({
            onCancel: () => navigate(Paths.LEC_BANK_ACCOUNTS_LIST_PAGE),
            onUpdate: async (values) => {
              const response = await createLecBankAccountMutation(values)
              navigate(Paths.LEC_BANK_ACCOUNTS_UPDATE_PAGE.replace(':id', response.id.toString()))
            },
            onUpdateThenCreate: async (values) => {
              await createLecBankAccountMutation(values)
              setFormKey((prev) => prev + 1)
            },
            onUpdateThenList: async (values) => {
              await createLecBankAccountMutation(values)
              navigate(Paths.LEC_BANK_ACCOUNTS_LIST_PAGE)
            }
          })}
        />
      </Box>
    </div>
  )
}

export default LecBankAccountCreatePage
